export class BankAccount {
  public bankName: string;
  public type: string;
  public accountNumber: string;

  constructor(bankName: string, type: string, accountNumber: string) {
    this.bankName = bankName;
    this.type = type;
    this.accountNumber = accountNumber;
  }

  get maskedAccountNumber(): string {
    return this.accountNumber.replace(/x+/gi, '*****');
  }

  get displayInfo(): string {
    return `${this.bankName},  ${this.type} ${this.maskedAccountNumber}`;
  }
}
